import { Component, OnInit, Inject , ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';


export interface IgmsAlertData {
  message: string;
  buttonText?: string;
  title?: string;
  noButtons?: boolean
};

@Component({
    selector: 'app-gms-alert',
    templateUrl: './gms-alert.component.html',
    styleUrls: ['./gms-alert.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GmsAlertComponent implements OnInit {
  message: string = ""
  cancelButtonText = "Cancel";
  title: string;
  noButtons: boolean = false;
  constructor(
    public dialogRef: MatDialogRef<GmsAlertComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IgmsAlertData) {
    if (data) {
      this.message = data.message || this.message;
      if (data.buttonText) {
        this.cancelButtonText = data.buttonText || this.cancelButtonText;
      }
      data.title && (this.title = data.title);
      this.noButtons = !!data.noButtons;
    }
    this.dialogRef.updateSize('300vw', '300vw');
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit(): void {
  }

}
